import { Component, inject, ViewContainerRef } from '@angular/core';
import { TooltipService } from '../../services/tooltip.service';

@Component({
  selector: 'ui-tooltips',
  template: '',
})
export class Tooltips {
  private viewContainer = inject(ViewContainerRef);
  private tooltipService = inject(TooltipService);

  constructor() {
    this.tooltipService.setViewContainerRef(this.viewContainer);
  }
}
